export interface RouteTrailEntry {
  path: string;
  at: string;
}

const MAX_ROUTES = 10;
const trail: RouteTrailEntry[] = [];

/** Remember a screen the learner landed on. Path only, never the query string
 *  (it can carry tokens). Keeps the last 10, in memory. */
export function recordRoute(path: string): void {
  if (trail[trail.length - 1]?.path === path) return;
  trail.push({ path, at: new Date().toISOString() });
  if (trail.length > MAX_ROUTES) trail.shift();
}

/** The last screens visited, oldest first. Sent with an issue report. */
export function recentRoutes(): RouteTrailEntry[] {
  return [...trail];
}
